var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAdvertisementIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0537 10.9955L25.2616 5.94298C26.1098 5.11997 27.3305 4.8077 28.4698 5.12223C29.609 5.43676 30.4966 6.33106 30.8025 7.4727L34.8822 22.6985C35.1881 23.8402 34.8667 25.0585 34.0373 25.9005C33.2079 26.7425 31.9946 27.0824 30.8484 26.7938L23.8121 25.0219",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.325 13.8706L20.0545 10.9956L23.8128 25.022L13.0834 27.897C9.97147 28.7308 6.77283 26.8841 5.93901 23.7722L5.20022 21.015C4.79979 19.5206 5.0094 17.9284 5.78294 16.5885C6.55649 15.2487 7.83061 14.271 9.325 13.8706Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.678 25.8619L21.9622 30.6547C22.191 31.5087 22.0712 32.4185 21.6291 33.1841C21.1871 33.9497 20.459 34.5084 19.6051 34.7372L19.0513 34.8856C18.1974 35.1144 17.2875 34.9946 16.5219 34.5526C15.7562 34.1106 15.1976 33.3825 14.9688 32.5286L13.6846 27.7358",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdvertisementIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AdvertisementIcon.396b4a5a.svg";
export { ForwardRef as ReactComponent };